import { QueryParams } from "@app/store/types";

export const generateParamsFilters = (params: QueryParams): string => {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value) searchParams.append(key, value);
    });

    return searchParams.toString() ? `?${searchParams.toString()}` : "";
};